import React from "react";
import ProcessSteps from "../../../Shared/ProcessSteps/ProcessSteps";

const selfPublishingSteps = [
  { title: "원고 접수 및 검토" },
  { title: "출판 계약 체결" },
  { title: "편집 및 디자인 작업" },
  { title: "인쇄 또는 전자출판 제작" },
  { title: "유통 및 판매 등록" },
  { title: "출간 후 마케팅 및 정산" },
];

const SelfPublishingProcess = () => {
  return <ProcessSteps title="자비 출판 과정" steps={selfPublishingSteps} />;
};

export default SelfPublishingProcess;
